<div class="salesdetailwrapper">
  <div class="salesreportwrapper">
    <div class="salesdetail text-heading-3" (click)="goBack()"><img class="previewback" src="../../../../assets/images/storelist/backarrow.svg">Generate Custom Report</div>
  </div>
  <div class="mb-3 d-flex align-items-center">
    <h2 class="header store-content">Store</h2>
    <div class="cabinet-dropdown stores"> 
      <span class="drop-down-btn header ms-2 d-flex align-items-center justify-content-between" (click)="isDropDown.set(!isDropDown())">
          <span>{{ changedStoreName }}</span>
          <img src="../../../assets/images/dropdown.png" [class]="isDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
      </span>
      <ul class="dropdown-menu" [class]="isDropDown() ? 'd-block' : ''">
        <li *ngFor="let names of storeNames" class="dropdown-item" (click)="onStoreNameChange(names.id, names.name)">{{ names.name }}</li>
      </ul>
    </div>
  </div>
  <div class="datesection d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <div class="startdate-content">Start Date</div>
      <mat-form-field>
        <input  matInput [matDatepicker]="startDate" placeholder="DD/MM/YYYY" (dateChange)="addEvent('start', $event)">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      <div class="endDate-content">End Date</div>
      <mat-form-field color="blue">
        <input matInput [matDatepicker]="endDate"  placeholder="DD/MM/YYYY" (dateChange)="addEvent('end', $event)">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>
      <div class="header report-content">Type of report</div>
      <div class="cabinet-dropdown stores">
        <span class="drop-down-btn header ms-2 d-flex align-items-center justify-content-between" (click)="isDropDownPeriod.set(!isDropDownPeriod())">
            <span>{{ changedStorePeriod }}</span>
            <img src="../../../assets/images/dropdown.png" [class]="isDropDownPeriod() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
        </span>
        <ul class="dropdown-menu" [class]="isDropDownPeriod() ? 'd-block' : ''">
          <li *ngFor="let period of period" class="dropdown-item" (click)="onStorePeriodChange(period)">{{ period.period }}</li>
        </ul>
      </div>
    </div>
    <button class="primary-btn addproduct" (click)="generateReport()">Generate Report</button>
  </div>
  <div class="salesreportwrappers">
    <div class="reportpreview">Report Preview</div>
    <button class="primary-btn" (click)="downloadSalesRecords(changedStorePeriod,currentStoreId)">Download Report</button>
  </div>
  <div class="table-wrapper userstable">
    <div *ngIf="salesProducts.length > 0">
   <table class="table">
     <thead>
       <tr>
         <th class="" scope="col">Stocks</th>
         <th class="" scope="col">Counts</th>
       </tr>
     </thead>
     <tbody>
       <tr>
         <td class="text-start">Total Stock</td>
         <td class="text-start">{{ paginationData.total }}</td>
       </tr>
     </tbody>
   </table>
   </div>
 </div>
 <div class="table-wrapper">
   <div *ngIf="salesProducts.length > 0" class="table-wrapper">
    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let heading of modifiedHeadings" class="" scope="col">{{ heading }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let salesOrder of salesProducts">
          <td *ngFor="let heading of tableHeadings" class="text-start">{{ salesOrder[heading] }}</td>
        </tr>
      </tbody>
    </table>
    <div class="" *ngIf="paginationData.totalPage > 1">
      <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
    </div>
  </div>
 </div>
</div>
